import styled from 'styled-components';
import Chip from '../Chip';
var Truncate = styled.span.withConfig({
  displayName: "Truncatestyles__Truncate",
  componentId: "sc-b8lnuq-0"
})(["display:inline-block;"]);
var EllipsisChip = styled(Chip).withConfig({
  displayName: "Truncatestyles__EllipsisChip",
  componentId: "sc-b8lnuq-1"
})(["margin:0 0 0 0.5rem;vertical-align:middle;"]);
var Text = styled.span.withConfig({
  displayName: "Truncatestyles__Text",
  componentId: "sc-b8lnuq-2"
})(["vertical-align:middle;"]);
export var Styled = {
  Truncate: Truncate,
  EllipsisChip: EllipsisChip,
  Text: Text
};